/*
 *   Sort an array of objects by an enum attribute using the order
 *   defined in enumOrder
 *
 */
const sortObjectsByEnum = (arr, attribute, enumOrder) => {
  const getIndex = (arr, val, defaultIndex) => {
    const index = arr.indexOf(val);
    return index !== -1 ? index : defaultIndex;
  };

  arr.sort((a, b) => {
    const aIndex = getIndex(enumOrder, a[attribute], Infinity);
    const bIndex = getIndex(enumOrder, b[attribute], Infinity);
    return aIndex - bIndex;
  });

  return arr;
};

export default sortObjectsByEnum;
